import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StimulsoftLoaderService {
  private isLoaded = false;
  private loadPromise: Promise<void> | null = null;

  loadStimulsoft(): Promise<void> {
    if (this.isLoaded) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      const scripts = [
        'assets/stimulsoft.reports.js',
        'assets/stimulsoft.viewer.js'
      ];

      const loadScript = (url: string): Promise<void> => {
        return new Promise((resolveScript, rejectScript) => {
          if (window.document.querySelector(`script[src="${url}"]`)) {
            resolveScript();
            return;
          }

          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = () => resolveScript();
          script.onerror = () => rejectScript(new Error(`Failed to load script: ${url}`));
          document.body.appendChild(script);
        });
      };

      const loadAll = async () => {
        try {
          for (const script of scripts) {
            await loadScript(script);
          }
          this.isLoaded = true;
          resolve();
        } catch (error) {
          reject(error);
        }
      };

      loadAll();
    });

    return this.loadPromise;
  }

  isStimulsoftLoaded(): boolean {
    return this.isLoaded && !!(window as any).Stimulsoft;
  }

  isStimulsoftLoading(): boolean {
    return !this.isLoaded && this.loadPromise !== null;
  }
}
